const WorkingCapitalTypes = {
  AccountReceivable: "account_receivable",
  Inventory: "inventory",
  AccountPayable: "account_payable",
};

export { WorkingCapitalTypes };
